module.exports = __webpack_public_path__ + "img/detail-introduce.f780914c.svg";